// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3pbc5","active":"NavigationItem_active__3mO9A"};